import type { InternalAxiosRequestConfig } from "axios";
import axios from "axios";
import Cookies from "js-cookie";

export const http = axios.create({
    baseURL: "/api/v1",
    withCredentials: true,
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken",
    headers: { "X-Requested-With": "XMLHttpRequest" },
});

function includeDevCookie(
    config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
    if (process.env.NODE_ENV !== "development") {
        return config;
    }
    const devCookie: string | undefined = Cookies.get("dev_cookie");
    if (devCookie) {
        config.headers.set("x-dev-cookie", devCookie);
    }
    return config;
}

http.interceptors.request.use((config) => {
    // Ensure CSRF header is present for unsafe methods
    const method = (config.method || "get").toUpperCase();
    const needsToken = ["POST", "PUT", "PATCH", "DELETE"].includes(method);
    if (needsToken && !config.headers?.["X-CSRFToken"]) {
        const token = Cookies.get("csrftoken");
        if (token) {
            config.headers.set("X-CSRFToken", token);
        }
    }
    if (process.env.NODE_ENV === "development") {
        return includeDevCookie(config);
    }
    return config;
});

http.interceptors.response.use(
    (r) => r,
    (error) => {
        // Bubble up error; central place to handle 401/403 if required
        return Promise.reject(error);
    },
);
